import React from 'react'

const ScoreDisplay = ({ score, type }) => {
  const bgColor = type === 'ACT' ? '#0DCAF0' : '#4E57EF'

  return (
    <div
      className="text-white self-stretch min-h-8 w-8 h-8 my-auto rounded-[10px] flex items-center justify-center text-sm font-medium whitespace-nowrap leading-[1.2]"
      style={{ backgroundColor: bgColor }}
    >
      {score}
    </div>
  )
}

export default ScoreDisplay
